function buildPageCategoriesArr(): string[] {
	if (
		!window.pageMeta ||
		!Array.isArray(window.pageMeta.breadCrumbs) ||
		!window.pageMeta.breadCrumbs.length
	)
		return []
	const categories: string[] = []
	// Filter the first 2 levels (home page and country)
	for (const breadCrumb of window.pageMeta.breadCrumbs) {
		if (breadCrumb.level > 2) {
			categories.push(breadCrumb.label)
		}
	}

	return categories
}

export default buildPageCategoriesArr
